import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

export const STAIRS_NODES: IconNode = [
  [
    'path',
    {
      key: 'stairs-0',
      d: 'M4 18H8V14H12V10H16V6H20',
    },
  ],
]

export const StairsIcon: LucideIcon = createLucideIcon('stairs', STAIRS_NODES)
